(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-rail]').forEach((section) => {
    const rail = section.querySelector('.featured-collection__grid');
    const previous = section.querySelector('[data-rail-previous]');
    const next = section.querySelector('[data-rail-next]');
    if (!rail || !previous || !next) return;

    const move = (direction) => {
      rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.72, 280), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileMenu = document.querySelector('#MobileMenu');
  const menuOpen = document.querySelector('[data-menu-open]');
  const menuCloses = document.querySelectorAll('[data-menu-close]');
  const searchDialog = document.querySelector('#SearchDialog');
  const searchOpen = document.querySelector('[data-search-open]');
  const searchClose = document.querySelector('[data-search-close]');

  if (menuOpen && menuCloses.length && mobileMenu) {
    let closeTimer;

    const openMobileMenu = () => {
      window.clearTimeout(closeTimer);
      mobileMenu.hidden = false;
      mobileMenu.setAttribute('aria-hidden', 'false');
      menuOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
      window.requestAnimationFrame(() => {
        mobileMenu.classList.add('is-open');
        mobileMenu.querySelector('.mobile-menu__close')?.focus({ preventScroll: true });
      });
    };

    const closeMobileMenu = () => {
      mobileMenu.classList.remove('is-open');
      menuOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      closeTimer = window.setTimeout(() => {
        mobileMenu.hidden = true;
        mobileMenu.setAttribute('aria-hidden', 'true');
        menuOpen.focus({ preventScroll: true });
      }, 430);
    };

    menuOpen.addEventListener('click', openMobileMenu);
    menuCloses.forEach((button) => button.addEventListener('click', closeMobileMenu));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMobileMenu();
    });
  }

  if (searchOpen && searchClose && searchDialog) {
    searchOpen.addEventListener('click', () => {
      searchDialog.showModal();
      searchDialog.querySelector('input').focus();
    });

    searchClose.addEventListener('click', () => searchDialog.close());

    searchDialog.addEventListener('click', (event) => {
      if (event.target === searchDialog) searchDialog.close();
    });
  }

  const cartDrawer = document.querySelector('#CartDrawer');
  const cartOpen = document.querySelector('[data-cart-open]');
  const cartClose = document.querySelector('[data-cart-close]');

  if (cartDrawer && cartOpen && cartClose) {
    cartOpen.addEventListener('click', (event) => {
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      event.preventDefault();
      cartDrawer.showModal();
      cartClose.focus({ preventScroll: true });
    });

    cartClose.addEventListener('click', () => {
      cartDrawer.close();
      cartOpen.focus({ preventScroll: true });
    });

    cartDrawer.addEventListener('click', (event) => {
      if (event.target === cartDrawer) cartDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-video-overlay"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{const overlay=document.querySelector('[data-gomanby-home-video-overlay]');const media=document.querySelector('.home-main__hero--complete-artwork .home-main__hero-media');if(!overlay||!media)return false;if(overlay.parentElement!==media)media.appendChild(overlay);media.style.position='absolute';media.style.overflow='hidden';media.querySelectorAll('.home-main__hero-image').forEach(i=>{i.style.visibility='hidden';i.style.opacity='0';i.style.display='none'});overlay.style.display='block';overlay.style.visibility='visible';overlay.style.opacity='1';const d=overlay.querySelector('.gomanby-home-video--desktop'),m=overlay.querySelector('.gomanby-home-video--mobile');const sync=()=>{const mobile=window.matchMedia('(max-width:749px)').matches;const a=mobile?m:d,b=mobile?d:m;if(!a||!b)return;b.pause();a.muted=true;a.loop=true;a.setAttribute('muted','');a.setAttribute('playsinline','');a.setAttribute('autoplay','');a.load();const play=()=>{const p=a.play();if(p&&typeof p.catch==='function')p.catch(()=>{})};if(a.readyState>=2)play();else a.addEventListener('canplay',play,{once:true});};sync();window.addEventListener('resize',sync,{passive:true});return true};const boot=()=>{if(init())return;let n=0;const r=()=>{if(init()||++n>30)return;setTimeout(r,100)};r()};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();window.addEventListener('load',boot,{once:true})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-main-home]').forEach((home) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = home.querySelectorAll('[data-home-reveal]');
    const hero = home.querySelector('[data-hero-slider]');
    const heroSlides = hero ? [...hero.querySelectorAll('[data-hero-slide]')] : [];
    const heroDots = [...home.querySelectorAll('[data-hero-dot]')];
    let heroIndex = 0;
    let heroRotation = null;
    let heroTouchStart = 0;

    const showHero = (index) => {
      if (!heroSlides.length) return;
      heroIndex = (index + heroSlides.length) % heroSlides.length;
      heroSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === heroIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      heroDots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-pressed', String(dotIndex === heroIndex));
      });
    };

    const stopHero = () => {
      if (heroRotation) window.clearInterval(heroRotation);
      heroRotation = null;
    };

    const startHero = () => {
      stopHero();
      if (!reduceMotion && heroSlides.length > 1) {
        heroRotation = window.setInterval(() => showHero(heroIndex + 1), 7800);
      }
    };

    heroDots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        showHero(dotIndex);
        startHero();
      });
    });

    if (hero) {
      hero.addEventListener('mouseenter', stopHero);
      hero.addEventListener('mouseleave', startHero);
      hero.addEventListener('touchstart', (event) => {
        heroTouchStart = event.changedTouches[0]?.clientX || 0;
        stopHero();
      }, { passive: true });
      hero.addEventListener('touchend', (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - heroTouchStart;
        if (Math.abs(distance) > 42) showHero(heroIndex + (distance < 0 ? 1 : -1));
        startHero();
      }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopHero();
        else startHero();
      });
    }

    showHero(0);
    startHero();

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('home-reveal-visible'));
    } else {
      home.classList.add('home-motion-ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('home-reveal-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
      );
      items.forEach((item) => observer.observe(item));
    }

    const track = home.querySelector('[data-review-track]');
    const slides = track ? [...track.querySelectorAll('[data-review-slide]')] : [];
    if (!track || slides.length < 2) return;

    let current = 0;
    const goTo = (index) => {
      current = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[current].offsetLeft - track.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    };

    home.querySelector('[data-review-previous]')?.addEventListener('click', () => goTo(current - 1));
    home.querySelector('[data-review-next]')?.addEventListener('click', () => goTo(current + 1));

    if (!reduceMotion) {
      let rotation = window.setInterval(() => goTo(current + 1), 5500);
      const pause = () => window.clearInterval(rotation);
      const resume = () => {
        window.clearInterval(rotation);
        rotation = window.setInterval(() => goTo(current + 1), 5500);
      };
      track.addEventListener('mouseenter', pause);
      track.addEventListener('mouseleave', resume);
      track.addEventListener('focusin', pause);
      track.addEventListener('focusout', resume);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('.main-product__form');
    const variantInput = root.querySelector('[data-variant-input]');
    const price = root.querySelector('[data-product-price]');
    const sale = root.querySelector('[data-product-sale]');
    const button = root.querySelector('[data-add-button]');
    const buttonText = root.querySelector('[data-add-text]');
    const stickyBar = root.querySelector('[data-mobile-purchase]');
    const stickyButton = root.querySelector('[data-sticky-add]');
    const stickyText = root.querySelector('[data-sticky-add-text]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const decrease = root.querySelector('[data-quantity-decrease]');
    const increase = root.querySelector('[data-quantity-increase]');
    const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const previous = root.querySelector('[data-gallery-previous]');
    const next = root.querySelector('[data-gallery-next]');
    const counter = root.querySelector('[data-gallery-counter]');
    const zoomButtons = Array.from(root.querySelectorAll('[data-gallery-zoom]'));
    const lightbox = root.querySelector('[data-product-lightbox]');
    const lightboxImage = root.querySelector('[data-lightbox-image]');
    const lightboxCounter = root.querySelector('[data-lightbox-counter]');
    const lightboxPrevious = root.querySelector('[data-lightbox-previous]');
    const lightboxNext = root.querySelector('[data-lightbox-next]');
    const lightboxClose = root.querySelector('[data-lightbox-close]');
    let activeMedia = 0;
    let activeLightboxImage = 0;
    let lightboxPreviousOverflow = '';

    const showMedia = (index) => {
      if (!slides.length) return;
      activeMedia = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeMedia;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeMedia;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      if (counter) counter.textContent = `${activeMedia + 1} / ${slides.length}`;
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.galleryThumb)));
    });
    if (previous) previous.addEventListener('click', () => showMedia(activeMedia - 1));
    if (next) next.addEventListener('click', () => showMedia(activeMedia + 1));

    const showLightboxImage = (index) => {
      if (!zoomButtons.length || !lightboxImage) return;
      activeLightboxImage = (index + zoomButtons.length) % zoomButtons.length;
      const trigger = zoomButtons[activeLightboxImage];
      lightboxImage.src = trigger.dataset.fullImage;
      lightboxImage.alt = trigger.dataset.fullAlt || '';
      if (lightboxCounter) lightboxCounter.textContent = `${activeLightboxImage + 1} / ${zoomButtons.length}`;
    };

    zoomButtons.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        if (!lightbox) return;
        showLightboxImage(index);
        lightboxPreviousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        if (typeof lightbox.showModal === 'function') {
          lightbox.showModal();
        } else {
          lightbox.setAttribute('open', '');
        }
        lightboxClose?.focus();
      });
    });

    const closeLightbox = () => {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
      document.body.style.overflow = lightboxPreviousOverflow;
    };

    lightboxClose?.addEventListener('click', closeLightbox);
    lightboxPrevious?.addEventListener('click', () => showLightboxImage(activeLightboxImage - 1));
    lightboxNext?.addEventListener('click', () => showLightboxImage(activeLightboxImage + 1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('close', () => {
      document.body.style.overflow = lightboxPreviousOverflow;
    });

    root.querySelectorAll('[data-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        const available = radio.dataset.available === 'true';
        const comparePrice = radio.dataset.comparePrice;
        const discount = Number(radio.dataset.discount || 0);

        if (variantInput) variantInput.value = radio.value;
        if (price) {
          price.innerHTML = comparePrice
            ? `<span class="visually-hidden">${root.dataset.regularLabel}</span><s>${comparePrice}</s><span class="visually-hidden">${root.dataset.saleLabel}</span><strong>${radio.dataset.price}</strong>`
            : `<strong>${radio.dataset.price}</strong>`;
        }
        if (sale) {
          sale.textContent = discount > 0 ? `${root.dataset.saveLabel} ${discount}%` : '';
          sale.classList.toggle('is-hidden', discount === 0);
        }
        if (button) button.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
        if (buttonText) buttonText.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
        if (stickyText) stickyText.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    if (decrease && quantityInput) {
      decrease.addEventListener('click', () => {
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      });
    }

    if (increase && quantityInput) {
      increase.addEventListener('click', () => {
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      });
    }

    if (stickyButton && form) {
      stickyButton.addEventListener('click', () => form.requestSubmit(button));
    }

    if (stickyBar && button && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.15 }
      );
      observer.observe(button);
    }
  });

  if (!window.gomanbyProductMotionInitialized) {
    window.gomanbyProductMotionInitialized = true;
    const revealItems = Array.from(document.querySelectorAll('[data-gmb-reveal]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.documentElement.classList.add('gmb-motion-ready');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-gmb-visible'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-gmb-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );

      revealItems.forEach((item) => revealObserver.observe(item));
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(() => {});
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
